const { Core, Events, DOMEvents, Utils } = Global;
const { $state } = Utils;

customElements.define('cart-variant-selector-modal-min-product', class extends Core {
    elements = {
        modal: 'modal-container'
    }

    propTypes = {
        'old-key': String,
        'old-line-index': Number,
        'quantity': Number
    };

    render() {
        this.$({ change: this._publishChange });
        this.$('modal', {'modal-close': this._handleClose } );
    }

    _publishChange(e) {
        e.stopPropagation();
        e.preventDefault();

        var prodId = e.target.getAttribute('data-product-id');
        var variantId = e.target.value;
        var variantImg = e.target.getAttribute('data-variant-img');
        var variantTitle = e.target.getAttribute('data-variant-title');

        var currentProduct = document.querySelector('.\\#product-card-min[data-product-id="' + prodId + '"]');
        if (currentProduct != null) {
          var currentProductToCart = currentProduct.querySelector('product-to-cart');
          var currentProductImage = currentProduct.querySelector('.\\#media-image');
          var currentProductOptValue = currentProduct.querySelector('.\\#product-card-min-info-option-value');

          if (currentProductToCart != null) {
            currentProductToCart.setAttribute('variant-id', variantId);
          }

          if (currentProductImage != null) {
            currentProductImage.setAttribute('src', variantImg);
            currentProductImage.removeAttribute('srcset');
          }

          if (currentProductOptValue != null) {
            currentProductOptValue.innerHTML = variantTitle;
          }
        }
      
        this.$('modal').close();
    }
    
    _handleClose(e) {
        e.stopPropagation();
    }
})